import {SET_ADDRESS} from 'src/pages/localChannelLineup/store/actions/setAddress';

export const address = (state = null, {type, value} = {}) => {
  switch (type) {
    case SET_ADDRESS:
      return value.address;
    default:
      return state;
  }
};
